import type { UsersTranslations } from "../interfaces/users";

export const usersTranslations: UsersTranslations = {
  page_title: "Usuários",
  page_subtitle: "Pessoas com acesso à plataforma, em todas as organizações.",
  page_subtitle_single_org: "Pessoas com acesso à plataforma na sua organização.",
  action_refresh: "Atualizar",
  action_create: "Criar usuário",

  stat_no_roles: "pessoas sem nenhuma função atribuída. Conseguem entrar e não veem nada.",
  stat_no_roles_zero: "Todas as pessoas têm pelo menos uma função atribuída.",

  tile_group_label: "Filtro por estado",
  tile_total: "Total",
  tile_active: "Ativos",
  tile_unverified: "Sem verificar",
  tile_suspended: "Suspensos",
  tile_inactive: "Desativados",
  tile_other_status: "{{count}} em outro estado",

  search_placeholder: "Buscar por nome ou e-mail",
  search_min_hint: "Digite pelo menos 3 caracteres para buscar. Os demais filtros continuam valendo.",
  filter_role_label: "Função",
  filter_role_all: "Todas as funções",
  filter_role_unavailable:
    "Não foi possível carregar o catálogo de funções, então não dá para filtrar por função.",

  col_person: "Pessoa",
  col_organization: "Organização",
  col_access: "Acesso",
  col_status: "Estado",
  col_account_access: "Acesso à conta",
  col_actions: "Ações",
  badge_you: "Você",
  badge_coloca: "Coloca",
  row_actions_label: "Ações para {{name}}",

  status_active: "Ativo",
  status_inactive: "Desativado",
  status_suspended: "Suspenso",
  status_pending_verification: "Sem verificar",

  signin_suspended: "Suspenso",
  signin_inactive: "Desativado",
  signin_locked: "Bloqueado · {{minutes}} min",
  signin_unverified: "E-mail sem verificar",
  signin_never: "Nunca entrou",
  signin_failing: "{{count}} tentativas falhas",
  signin_failing_one: "{{count}} tentativa falha",
  signin_suspended_title: "Qualquer tentativa de entrar é recusada enquanto estiver suspenso.",
  signin_inactive_title: "A conta está desativada e não consegue entrar.",
  signin_locked_title: "O bloqueio se levanta sozinho. Nada o encurta.",
  signin_unverified_title: "O e-mail não está verificado.",
  signin_never_title: "Esta pessoa nunca entrou.",
  signin_failing_title: "Tentativas falhas acumuladas. Na quinta a conta bloqueia por 30 minutos.",
  signin_ok_title: "Último acesso: {{date}}",

  org_none: "Sem organização",
  org_unresolved: "não resolvido",
  org_internal: "interna",
  org_directory_failed:
    "Não foi possível carregar os nomes das organizações. Os dados dos usuários não são afetados.",
  org_directory_truncated:
    "Há mais organizações do que foi possível pré-carregar. Os nomes que faltam são resolvidos quando aparecem.",
  org_directory_loading: "Carregando organizações…",
  org_directory_empty: "Não há organizações para selecionar.",

  access_none: "Sem funções",
  access_unavailable: "Funções indisponíveis",
  access_tally: "{{allowed}}/{{total}} permissões",
  access_extra: "+{{count}}",

  action_view: "Ver e editar",
  action_manage_access: "Gerenciar acessos",
  action_verify_email: "Verificar e-mail",
  action_activate: "Ativar",
  action_deactivate: "Desativar",
  action_suspend: "Suspender",
  action_set_password: "Definir senha",
  action_delete: "Excluir",
  action_cancel: "Cancelar",

  empty_title: "Ainda não há usuários",
  empty_body: "Crie a primeira pessoa com acesso à plataforma.",
  empty_filtered_title: "Nenhum usuário corresponde aos filtros",
  empty_filtered_body: "Ajuste a busca, o estado ou a função para ver a população completa de novo.",
  empty_clear_filters: "Limpar filtros",
  error_load_failed: "Não foi possível carregar a lista de usuários.",
  error_retry: "Tentar de novo",

  create_title: "Criar usuário",
  create_subtitle: "Criado como membro de uma organização.",
  create_field_full_name: "Nome completo",
  create_field_email: "E-mail",
  create_field_organization: "Organização",
  create_field_organization_placeholder: "Busque a organização",
  create_field_language: "Idioma",
  create_field_country: "País",
  create_field_phone: "Telefone",
  create_field_phone_hint: "Com código do país e sem o símbolo +. Exemplo: 573101234567.",
  create_section_credentials: "Credenciais de acesso",
  create_field_password: "Senha",
  create_generate: "Gerar",
  create_note_must_change: "Será pedido que troque esta senha no primeiro acesso.",
  create_note_no_email: "Nenhum e-mail é enviado — entregue a senha por um canal seguro.",
  create_submit: "Criar usuário",
  create_success: "Usuário criado",

  detail_section_data: "Dados",
  detail_section_access: "Acesso",
  detail_section_password: "Senha",
  detail_section_activity: "Atividade",
  detail_email_warning: "Trocar o e-mail apaga a verificação: a pessoa volta para «E-mail sem verificar».",
  detail_phone_hint: "Deixe vazio para removê-lo.",
  detail_org_label: "Organização",
  detail_save: "Salvar alterações",
  detail_close: "Fechar",
  detail_saved: "Alterações salvas",
  detail_alert_locked:
    "O bloqueio se levanta sozinho em {{minutes}} minutos. Nada o encurta: trocar a senha não deixa a pessoa entrar.",
  detail_alert_two_factor:
    "Esta conta pode ter 2FA ativo sem dispositivo inscrito. Vale revisar: definir uma senha nova não resolve.",
  detail_access_summary_none: "Sem funções atribuídas. Consegue entrar e não vê nada.",
  detail_access_summary_unavailable:
    "Não foi possível ler as funções desta pessoa. Não é o mesmo que não ter nenhuma.",
  detail_access_summary: "{{count}} funções atribuídas · {{allowed}}/{{total}} permissões efetivas",
  detail_access_summary_one: "{{count}} função atribuída · {{allowed}}/{{total}} permissões efetivas",
  detail_manage_access: "Gerenciar acessos",

  activity_created: "Criado",
  activity_updated: "Última atualização",
  activity_last_login: "Último acesso",
  activity_password_changed: "Senha alterada",
  activity_email_verified: "E-mail verificado",
  activity_failed_attempts: "Tentativas falhas",
  activity_locked_until: "Bloqueado até",
  activity_two_factor_flag: "2FA (indicador)",
  activity_never: "Nunca",
  activity_yes: "Sim",
  activity_no: "Não",

  password_new: "Nova senha",
  password_confirm: "Confirmar",
  password_requirements: "Entre 8 e 128 caracteres, com maiúscula, minúscula, número e símbolo.",
  password_mismatch: "As senhas não coincidem.",
  password_note_sessions: "Isto não encerra as sessões abertas da pessoa.",
  password_note_no_force: "Não será pedido que troque no próximo acesso.",
  password_note_no_email: "Nenhum e-mail é enviado.",
  password_note_compromised: "Se a conta estiver comprometida: suspenda primeiro, depois troque a senha.",
  password_submit: "Definir senha",
  password_success: "Senha atualizada",

  suspend_title: "Suspender {{name}}?",
  suspend_body: "As sessões já abertas não são encerradas, mas qualquer acesso futuro será recusado.",
  suspend_confirm: "Suspender",
  delete_title: "Excluir {{name}}?",
  delete_body: "Só é reversível pela engenharia, e todas as sessões da pessoa são encerradas na hora.",
  delete_email_note: "O e-mail continua ocupado: você não poderá criar outra pessoa com ele.",
  delete_confirm: "Excluir",
  delete_success: "Usuário excluído",

  verify_email_success: "E-mail verificado",
  status_change_success: "Estado atualizado",
  error_email_taken: "Já existe um usuário com este e-mail.",
  error_email_deleted_reuse:
    "Não foi possível criar. Se este e-mail pertenceu a um usuário excluído, não pode ser reutilizado: tente outro.",
  validation_required: "Este campo é obrigatório.",
  validation_email: "Digite um e-mail válido.",
};
